import { render, staticRenderFns } from "./aShopDetailHouse.vue?vue&type=template&id=fe8f301a&scoped=true"
import script from "./aShopDetailHouse.vue?vue&type=script&lang=js"
export * from "./aShopDetailHouse.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailHouse.vue?vue&type=style&index=0&id=fe8f301a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8f301a",
  null
  
)

export default component.exports